import { defineMessage } from 'services/localization';

export const messages = {
    purchaseOrderShort: defineMessage('po'),
    description: defineMessage('please_note_the_line_it_ost_price_in_systemname'),
    expectedPriceText: defineMessage('inventory_cost_price'),
    actualPriceText: defineMessage('price_in_this_requestname'),
    differenceText: defineMessage('difference'),
    xeroSystemName: defineMessage('xeros_inventory'),
    netSuiteSystemName: defineMessage('oracle_netsuite'),
    qBooksSystemName: defineMessage('quickbooks_online_inventory'),
    multiCurrencyDescription: defineMessage('please_note_the_price_c_ffers_from_contacts_one'),
};
